import React, { useEffect, useState } from 'react';
import {emailHistories as emailHistoriesDuck, flashMessages, modals } from '../../ducks';
import { duckify, filterDuck, singleDuck } from '../../utils/duckify';
import {formatDateTime, getMetaContent} from 'utils';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons/faPaperclip';
import { users } from '../../ducks/index'

import withPagination from 'hocs/withPagination';
import withSorting from 'hocs/withSorting';
import ContactList from 'components/ContactList/ContactList';
import withFiltering from 'hocs/withFiltering';

import Pagination from 'react-ultimate-pagination-bootstrap-4';
import Filters from 'components/Filters/Filters';

import './styles/EmailList.scss';
import DateFilter from "components/shared/DateFilter";
import FlashRoot from "components/FlashMessage/FlashRoot";
import FontAwesome from "utils/FA";
import InfoTooltip from 'components/shared/InfoTooltip';
import withDateFilter from '../../hocs/withDateFilter';
import BulkAction from "../ContactList/BulkActions/BulkAction";
import {faDoNotEnter} from "@fortawesome/pro-solid-svg-icons/faDoNotEnter";
import ExportControls from "../shared/ExportControls";
import { entity as emailSnippets } from '../../ducks/emailSnippets';

const EmailsList = ({ emailHistories, emailSnippets, onSort, sort, page, setPage, filters, setFilters, dispatch, dateFilter, currentUsers}) => {
  const columns = [
    {
      header: 'Sent On',
      sortName: 'sent_on',
      value: (history) => <td>{formatDateTime(history.sent_at)}</td>
    },
    { header: 'Opened On',
      value: (history) => <td>{history.info && history.info.opened_at && formatDateTime(history.info.opened_at)}</td>
    },
    {
      header: 'Clicked On',
      value: (history) => <td>{history.info && history.info.clicked_at && formatDateTime(history.info.clicked_at)}</td>
    },
    {
      header: 'Receiver Email',
      sortName: 'receiver_email',
      value: (history) => <td>{history.receiver_email}</td>
    },
    {
      header: 'Subject',
      sortName: 'subject',
      value: (history) => (
        <td>
          {history.subject}
          {history.has_attachment ? <FontAwesome icon={faPaperclip} preNbsp /> : ''}
        </td>
      )
    },
      { header: 'Sent',
        sortName: 'sent',
        value: (history) => <td><input type='checkbox' disabled={true} checked={!!history.sent}/></td>
      },
    {
      header: 'Receiver Name',
      sortName: 'receiver_name',
      value: (history) => <td>
        {history.contact_id  ?  <a href={'/contacts/' + history.contact_id}>{history.receiver_name}</a> : history.receiver_name }
       </td>
    },
    {
      header: 'On behalf of',
      sortName: 'on_behalf_of_name',
      value: (history) => <td>
        {history.on_behalf_of_id  ?  <a href={'/contacts/' + history.on_behalf_of_id}>{history.on_behalf_of_name}</a> : history.on_behalf_of_name }

      </td>
    },
    { header: "", value: (history) => <td>
        {<Button variant="link" className={"react-list-show-btn"} onClick={() => dispatch(modals.actions.show('MessageModal', {message: showEmail(history), title: "Email Details"})) }>Show</Button>}
        {currentUsers.communications_permitted && <span><text>|</text> <Button variant="link" className={"react-list-show-btn"} onClick={() => resend(history)}>Resend</Button></span>}
    </td>
    }]

  const templateFilterOption = () => {
    if (emailSnippets && emailSnippets.length > 0) {
      const snippets = emailSnippets.map(s => [s.name, s.id]);
      if (filters.snippet_id && filters.snippet_id.length > 0) {
        const pickedOption = emailSnippets.filter(s => s.id === filters.snippet_id[0]);
        if (pickedOption.length === 0) {
          snippets.push(['Template has been deleted', filters.snippet_id[0]]);
        }
      }
      return snippets;
    }
    return [];
  };

  const filterFields = [{
    filter_type: 'TextFilter',
    solr_prompt: 'on_behalf_of_name',
    display_name: 'On Behalf Of Name',
    tooltip: (
      <InfoTooltip preNbsp>
        Search for emails sent &quot;on behalf of&quot; contacts whose name contains this text.
      </InfoTooltip>
    )
  }, {
    filter_type: 'TextFilter',
    solr_prompt: 'receiver_email',
    display_name: 'Receiver Email',
    tooltip: <InfoTooltip preNbsp>Search for emails sent to this email address (must be exact).</InfoTooltip>
  }, {
    filter_type: 'TextFilter',
    solr_prompt: 'receiver_name',
    display_name: 'Receiver Name',
    tooltip: <InfoTooltip preNbsp>Search for emails sent to contacts whose name contains this text.</InfoTooltip>
  }, {
    filter_type: 'TextFilter',
    solr_prompt: 'subject',
    display_name: 'Subject',
    tooltip: <InfoTooltip preNbsp>Search for emails whose subject contains this text.</InfoTooltip>
  },
  {
    solr_prompt: 'opened',
    options: [['Yes', true], ['No', false]],
    display_name: 'Opened',
    tooltip: <InfoTooltip preNbsp>Search for emails that have or have not been opened.</InfoTooltip>
  },
  {
    filter_type: 'ManyOptionsFilter',
    solr_prompt: 'snippet_id',
    display_name: 'Email Template',
    options: templateFilterOption(),
    tooltip: <InfoTooltip preNbsp>Search for emails sent with this template.</InfoTooltip>
  }];

  const totalPages = Math.ceil(emailHistories.total / emailHistories.perPage);


  const showFlash = (props) => {
    dispatch(flashMessages.actions.show(props))
  };

  const resend = (history) => {
    let token = getMetaContent('csrf-token');
    fetch('/api/email_histories/resend', {
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json',  'X-CSRF-Token': token},
      method: 'POST',
      body: JSON.stringify(history)
    }).then(() =>  showFlash({
      message: `This email will be re-sent shortly.`
    }))
      .catch((e) =>  showFlash({
      message: `Email could not be re-sent. Please try again or contact support.`,
        type: 'error'
    }))
  };

  return (
    <div>
      <FlashRoot />
      <h2 className='inline'>
        Sent Emails
      </h2>

      <div className={"email-date-filter"}>
       <DateFilter
         useAll={false}
         useFutureOptions={false}
         customMessage={"Searching across more than one year may be slow."}
         dateFilter={dateFilter}
       />
      </div>

      <ExportControls type={'EmailHistoryCsvJob'}
                      location={location}
                      dateFilter={dateFilter}
                      url={"/api/email_histories/export"}
                      opts={{total: emailHistories.total}}
                      message={<React.Fragment>Your file is being prepared. You can safely close this modal and continue working. The report will automatically download
                        when completed and will also be available on the <a href='/setup/user_jobs' target={'_blank'}>User Jobs page.</a> </React.Fragment>}
      />

      <Filters
        fields={filterFields}
        selected={filters}
        submitFilters={setFilters}
      />
      {totalPages > 1 && (
        <div>
          <div className='react-pagination'>
            <div className='pagination pagination-right'>
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                hideFirstAndLastPageLinks
                onChange={setPage}
              />
            </div>
          </div>
        </div>
      )}


      <ContactList columns={columns}
                   contacts={emailHistories}
                   emptyMessage='There are no sent emails.'
                   onSort={onSort}
                   sort={sort}/>
    </div>);
};

const showEmail = (history) => {
  return (
    <div>
      <div className='email-modal-field-group'>
        <span className='email-modal-label'>Sent On</span>
        <span className='email-modal-value'>
          {formatDateTime(history.sent_at)}
        </span>
      </div>
      <div className='email-modal-field-group'>
        <span className='email-modal-label'>To</span>
        <span className='email-modal-value'>{history.receiver_email}</span>
      </div>

      {
        history.receiver_name && (
          <div className='email-modal-field-group'>
            <span className='email-modal-label'>Receiver Name</span>
            <span className='email-modal-value'>{history.receiver_name}</span>
          </div>
        )
      }

      <div className='email-modal-field-group'>
        <span className='email-modal-label'>On Behalf Of</span>
        <span className='email-modal-value'>{history.on_behalf_of_name}</span>
      </div>

      <div className='email-modal-field-group'>
        <span className='email-modal-label'>Subject</span>
        <span className='email-modal-value'>{history.subject}</span>
      </div>

      {history.info && history.info.opened_at && <div>
        <div className='email-modal-field-group'>
          <span className='email-modal-label'>Opened On</span>
          <span className='email-modal-value'>
          {formatDateTime(history.info.opened_at)}
        </span>
        </div>
      </div>
      }

      {history.info && history.info.clicked_at && (
        <div>
          <div className='email-modal-field-group'>
            <span className='email-modal-label'>Clicked On</span>
            <span className='email-modal-value'>
              {formatDateTime(history.info.clicked_at)}
            </span>
          </div>
        </div>
      )}

      <div className='email-modal-field-group'>
        <div className='email-modal-body' dangerouslySetInnerHTML={{ __html: history.body }} />
      </div>

      {
        history.has_attachment && history.attachment_names.map((attachment) => (
          <div className='email-modal-attachment' key={attachment}>
            <FontAwesome icon={faPaperclip} postNbsp />
            {attachment}
          </div>
        ))
      }

    </div>
  );
};

const mapDucksToProps = ({ location, sortJson, dateFilter }) => {
  const query = queryString.parse(location.search);

  return {
    emailHistories: filterDuck(emailHistoriesDuck, {
      ...query,
      ...dateFilter.queryParams,
      sort: sortJson,
    }),
    emailSnippets: filterDuck(emailSnippets, {}),
    currentUsers: singleDuck(users, 'current')
  };
};

export default compose(
  withRouter,
  withFiltering,
  withPagination,
  withSorting({
    column: 'updated_at',
    order: 'desc'
  }),
  withDateFilter(),
  duckify(mapDucksToProps))(EmailsList);
